import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, onWheel, ...props }, ref) => {
    // Browsers let the mouse wheel increment/decrement focused number
    // inputs by `step`. That silently corrupts values on pages with
    // scrollable content — e.g. typing 800 in an amount field then
    // scrolling toward the next control turns it into 799.98 (two
    // notches × step 0.01). Blurring the input on wheel cancels the
    // change without blocking explicit arrow-key edits.
    const handleWheel =
      type === "number"
        ? (e: React.WheelEvent<HTMLInputElement>) => {
            e.currentTarget.blur()
            onWheel?.(e)
          }
        : onWheel

    return (
      <input
        type={type}
        className={cn(
          "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus:border-input focus:outline-none focus:ring-1 focus:ring-ring aria-[invalid=true]:border-destructive aria-[invalid=true]:focus:border-destructive aria-[invalid=true]:focus:ring-destructive disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className
        )}
        ref={ref}
        onWheel={handleWheel}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
